import React from 'react';
import { Link } from 'react-router-dom';
import css from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={css.footer}>

      <div className={css.top}>
        <h2 className={css.text}>Powered by.</h2>
        <img className={css.logo} src="img/logo/horiz_KO_rgb.png" alt="" />
      </div>

      <div className={css.bottom}>
        <div className={css.bottomItem}>
          <div>
            <h2 className={css.text}>Contact Us</h2>
            <p>
              <a href="mailto:womentechmakersko@gmail.com" className={css.link}>
                Email
              </a>
            </p>
            <p>
              <a
                href="https://www.facebook.com/Women-Techmakers-Korea-473605092834438"
                target="_blank"
                rel="noopener noreferrer"
                className={css.text}
              >
                Facebook
              </a>
            </p>
          </div>
        </div>
        <div className={css.bottomItem}>
          <div>
            <h2 className={css.text}>Links</h2>
            <p>
              <Link to="/CodeOfConduct" className={css.text}>
                행동강령
              </Link>
            </p>
            <p>
              <Link to="/timeTable" className={css.text}>
                시간표
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
